import _ from 'lodash'
import type {CssValue} from '../../constants'
import {deserializeString} from '../utils/string'

const serialize = (val: any): CssValue | undefined => (_.isString(val) ? val : undefined)
const deserialize = (rule: CssValue): string | undefined => deserializeString(rule)

export default {
    serialize,
    deserialize
}
